var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,
    leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;


imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

addModify(window['canvas2']);



let toneArm = document.getElementById("tone_arm");

fabric.Image.fromURL(toneArm.src, function (img) {

  img.set({
    left: 1100,
    top: 290,
    scaleX: 0.78,
    scaleY: 0.78,
    selectable: false,
    evented: false,
    visible: true   // 🔹 IMPORTANT
  });

  window.toneArmPng = img;
  canvas2.add(img);
  img.bringToFront();
  canvas2.renderAll();
});


function keepToneArmOnTop() {
  if (window.toneArmPng && window.toneArmPng.visible) {
    canvas2.bringToFront(window.toneArmPng);
  }
}


document.addEventListener("DOMContentLoaded", function () {

  const toneArmSelect = document.querySelector(".tone_arm");

  toneArmSelect.addEventListener("change", function () {

    if (!window.toneArmPng) return;

    if (this.value === "Yes") {
      window.toneArmPng.set({ visible: true });
      keepToneArmOnTop();
    } else {
      window.toneArmPng.set({ visible: false });
    }

    canvas2.renderAll();
  });

});




$(document).ready(function () {
  let currentImage = null;

  function loadImage(url) {
    if (currentImage) {
      canvas2.remove(currentImage);
    }

    fabric.Image.fromURL(
      url,
      function (img) {
        img.set({
          left: 0,
          top: 0,
          selectable: false
        });
        img.scale(1);

        canvas2.add(img);
        currentImage = img;

        // Always keep background behind everything
        canvas2.sendToBack(currentImage);

        // Bring scrabble and text layers to front
        if (window.toneArmPng) canvas2.bringToFront(window.toneArmPng);
        if (window.text1Page) canvas2.bringToFront(window.text1Page);
        if (window.text2Page) canvas2.bringToFront(window.text2Page);

        canvas2.renderAll();
      },
      { crossOrigin: 'anonymous' }
    );
  }

  // Load default
  const defaultUrl = $('#icon1 img').attr('data-src');
  if (defaultUrl) {
    $('#icon1 img').addClass('active');
    loadImage(defaultUrl);
  }

  backgroundDesign = $('#shape_design a').first().data('title');

  // Background click
  $('#background_design a').on('click', function (e) {
    e.preventDefault();
    backgroundDesign = jQuery(this).data('title');
    // Remove active from all, add to selected
    $('#background_design img').removeClass('active');
    $(this).find('img').addClass('active');

    keepToneArmOnTop();
    if (window.toneArmPng) canvas2.bringToFront(window.toneArmPng);
    // Load selected background
    const url = $(this).find('img').attr('data-src');
    if (url) loadImage(url);
  });
});




function showCanvasLoader() {
    document.getElementById("canvasLoader").style.display = "flex";
}

function hideCanvasLoader() {
    document.getElementById("canvasLoader").style.display = "none";
}



  // ===============================
  // SVG SPIRAL FUNCTIONS
  // ===============================
function generateSpiralSVG(text) {

  text = text
    .replace(/\[[^\]]+\]/g, "")
    .replace(/\n+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  const innerRadius = 210;   // 345 / 2
  const outerRadius = 665;     // 1300 / 2
  const maxRadius = outerRadius - 10;

  let fontSize = 42;
  let spiralGap = 8;
  let thetaStep = 0.06;

  let pathD = "";
  let textFits = false;

  while (!textFits && fontSize >= 16) {

    let d = "";
    let theta = 0;
    let pathLength = 0;
    let lastX = null;
    let lastY = null;

    while (true) {
      const r = innerRadius + spiralGap * theta;
      if (r > maxRadius) break;

      const x = r * Math.cos(theta);
      const y = r * Math.sin(theta);

      // 👉 START PATH AT FIRST SPIRAL POINT (NO CENTER LINE)
      if (lastX === null) {
        d += `M ${x.toFixed(2)} ${y.toFixed(2)} `;
      } else {
        d += `L ${x.toFixed(2)} ${y.toFixed(2)} `;
        pathLength += Math.hypot(x - lastX, y - lastY);
      }

      lastX = x;
      lastY = y;
      theta += thetaStep;
    }

    const estimatedTextLength = text.length * fontSize * 0.55;

    if (pathLength >= estimatedTextLength) {
      pathD = d;
      textFits = true;
    } else {
      fontSize -= 2;
      spiralGap -= 0.4;
      spiralGap = Math.max(4.2, spiralGap);
    }
  }

  return `
<svg xmlns="http://www.w3.org/2000/svg"
     width="1400"
     height="1400"
     viewBox="-700 -700 1400 1400">
  <defs>
    <path id="spiralPath" d="${pathD}" />
  </defs>

  <text fill="${window.textColor || '#fff'}"
        font-size="${fontSize}"
        font-family="Arial"
        text-anchor="start">
    <textPath href="#spiralPath">
      ${text}
    </textPath>
  </text>
</svg>`;
}





/* ===============================
   DRAW SVG INTO FABRIC
================================ */
function drawSpiralLyricsSVG(text) {
  const canvas = window.canvas2;
  if (!canvas) return;

  const svg = generateSpiralSVG(text);
  const blob = new Blob([svg], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);

  fabric.Image.fromURL(url, img => {

    img.set({
      left: 700,
      top: 700,
      originX: "center",
      originY: "center",
      selectable: false,
      evented: false
    });

    if (window.lyricsGroup) {
      canvas.remove(window.lyricsGroup);
    }

    window.lyricsGroup = img;
    canvas.add(img);
    keepToneArmOnTop();
    canvas.renderAll();
  });
}


/* ===============================
   INIT
================================ */
document.addEventListener("DOMContentLoaded", () => {

  window.canvas2 = new fabric.Canvas("canvas2", {
    preserveObjectStacking: true
  });

  const textarea = document.getElementById("text_0");
  window.placeholderText = `Shining in the setting sun like a pearl upon the ocean
Come and feel me, o feel me
Shining in the setting sun like a pearl upon the ocean
Come and heal me, o heal me

Thinking about the love we making and a life we sharing
Come and feel me, o feel me
Shining in the setting sun like a pearl up on the ocean
Come and feel me, come on heal me

Hua jo tu bhi mera mera
Tera jo ikraar hua
To kyun na main bhi, keh doon keh doon
Hua mujhe bhi pyaar hua

Tera hone laga hoon, khone laga hoon
Jab se mila hoon
Tera hone laga hoon, khone laga hoon
Jab se mila hoon

Shining in the setting sun like a pearl upon the ocean
Come and feel me, o feel me
Shining in the setting sun like a pearl upon the ocean
Come and heal me, o heal me

Thinking about the love we making and a life we sharing
Come and feel me, o feel me
Shining in the setting sun like a pearl up on the ocean
Come and feel me, come on heal me

Hua jo tu bhi mera mera
Tera jo ikraar hua
To kyun na main bhi, keh doon keh doon
Hua mujhe bhi pyaar hua

Tera hone laga hoon, khone laga hoon
Jab se mila hoon
Tera hone laga hoon, khone laga hoon
Jab se mila hoon`;

  drawSpiralLyricsSVG(placeholderText);
  keepToneArmOnTop();

  textarea.addEventListener("input", () => {
    drawSpiralLyricsSVG(textarea.value || placeholderText);
  });
});

  // ===============================
  // SONG SEARCH
  // ===============================
  const songInput = document.getElementById("song_input");
  const songBox = document.getElementById("song_results");
  let searchTimer;

  songInput.addEventListener("input", function () {
    const q = this.value.trim();
    clearTimeout(searchTimer);

    if (q.length < 2) {
      songBox.style.display = "none";
      return;
    }

    searchTimer = setTimeout(() => searchSongs(q), 350);
  });

  function searchSongs(q) {
    fetch(`https://itunes.apple.com/search?term=${encodeURIComponent(q)}&entity=song&limit=20`)
      .then(r => r.json())
      .then(d => showSongs(d.results));
  }

  function showSongs(songs) {
    if (!songs.length) {
      songBox.innerHTML = "<div style='padding:10px;'>No results</div>";
      songBox.style.display = "block";
      return;
    }

    let html = "";
    songs.forEach(s => {
      html += `
        <div class="songItem"
             data-title="${s.trackName}"
             data-artist="${s.artistName}"
             data-img="${s.artworkUrl100}">
          <img src="${s.artworkUrl60}" alt="Cover">
          <div>
            <b>${s.trackName}</b><br>
            <small>${s.artistName}</small>
          </div>
        </div>`;
    });

    songBox.innerHTML = html;
    songBox.style.display = "block";

    document.querySelectorAll(".songItem").forEach(el => {
      el.addEventListener("click", function () {
        const title = this.dataset.title;
        const artist = this.dataset.artist;

        songInput.value = `${title} - ${artist}`;
        songBox.style.display = "none";

        showCanvasLoader();

        // 👉 NEW: Update Song Name field (text_1)
        const input1 = document.getElementById("text_1");
        input1.value = title;
        input1.dispatchEvent(new Event("input")); // update canvas

        // 👉 NEW: Update Artist Name field (text_2)
        const input2 = document.getElementById("text_2");
        input2.value = artist;
        input2.dispatchEvent(new Event("input")); // update canvas

        fetchLyrics(title, artist);
      });
    });
  }

  function fetchLyrics(title, artist) {

    showCanvasLoader();

    fetch(`https://api.lyrics.ovh/v1/${encodeURIComponent(artist)}/${encodeURIComponent(title)}`)
      .then(r => r.json())
      .then(d => {
        const lyrics = d.lyrics || "Lyrics not found.";
        const textarea = document.getElementById("text_0");
        textarea.value = lyrics;
        textarea.dispatchEvent(new Event("input"));
      })
      .catch(() => {
        const textarea = document.getElementById("text_0");
        textarea.value = "Lyrics not found.";
        textarea.dispatchEvent(new Event("input"));
      })
      .finally(() => {
        setTimeout(hideCanvasLoader, 400);
      });
  }




// function addSongThumbnailToCanvas(url) {
//     fabric.Image.fromURL(url, function(img){
//         img.set({
//             left: 100,
//             top: 100,
//             scaleX: 0.9,
//             scaleY: 0.9,
//             selectable: false
//         });
//         canvas2.add(img);
//         canvas2.sendToBack(img);
//     });
// }


function updateSpiralText(fullText) {
    const textarea = document.getElementById("text_0");

    // 👉 Update textarea with the new lyrics so user can edit
    textarea.value = fullText;

    // 👉 Trigger your existing textarea spiral drawing event
    textarea.dispatchEvent(new Event("input"));
    keepToneArmOnTop();
}






window['text1Page'] = new fabric.Text('check',{
  left: 690,
  top: 1600,
  fontSize: 150,
  fontFamily: 'Miguella Charlotte',
  fill: '#000',
  fontWeight: 'bolder',
  lockMovementX: true,
  lockMovementY: true,
  hasControls: false
});

var fontName = window['text1Page'].fontFamily;
jQuery('.choose_font1').val("'" + fontName + "'").trigger('change');

// Add to canvas
window['canvas2'].add(window['text1Page']);

// Clear text on input focus if default
document.getElementById('text_1').addEventListener('focus', function () {
  if (window['text1Page'].text === 'Kinza Rani') {
    window['text1Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


function fitTextToWidth(textObj, maxWidth) {
  let fontSize = 150; 
  textObj.set({ fontSize });


  while (textObj.width > maxWidth && fontSize > 5) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

document.getElementById('text_1').addEventListener('input', function (e) {
  const newText = e.target.value;
  window['text1Page'].set('text', newText);
  fitTextToWidth(window['text1Page'], 1250);
  window['text1Page'].bringToFront();
  window['canvas2'].renderAll();
});




var maxWidth = 1200;
var maxHeight = 280;

var para = "check" ;

window['text2Page'] = new fabric.Text(para,{
  left: 680,
  top: 1810,
  width: 1200,
  fontSize: 75,
  fontFamily: 'Dancing Script',
  fontWeight: 'bolder',
  textAlign: 'center',
  isWrapping: true,
  fill: '#000'
});


var fontName = window['text2Page'].fontFamily;
jQuery('.choose_font2').val("'" + fontName + "'").trigger('change');

window['canvas2'].add(window['text2Page']);


var minFontSize = 20;
var maxFontSize = 85;

// Clear text on input focus if default
document.getElementById('text_2').addEventListener('focus', function () {
  if (window['text2Page'].text === 'Lovable creatures that bring joy,\ncomfort, and endless companionship to us.') {
    window['text2Page'].set('text', '');
    window['canvas2'].renderAll();
  }
});


// Helper: Adjust font size to fit both width and height
function autoFitText(textbox, maxW, maxH) {
  let fontSize = maxFontSize;

  textbox.set({ fontSize });

  while (
    (textbox.width > maxW || textbox.calcTextHeight() > maxH) &&
    fontSize > minFontSize
  ) {
    fontSize -= 1;
    textbox.set({ fontSize });
  }

  window['canvas2'].renderAll();
}

// On input update
document.getElementById('text_2').addEventListener('input', function (e) {
  const input = e.target.value;
  window['text2Page'].set({
    text: input
  });
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});

function fitTextToBox(textObj, maxWidth, maxHeight) {
  let fontSize = maxFontSize;

  textObj.set({ fontSize });

  // Helper function to get height (fabric.Text uses height property)
  function isTooBig() {
    return textObj.width > maxWidth || textObj.height > maxHeight;
  }

  // Reduce font size until both width and height fit within limits
  while (isTooBig() && fontSize > minFontSize) {
    fontSize -= 1;
    textObj.set({ fontSize });
  }

  window['canvas2'].renderAll();
}



function updateFontShade(mode) {

  // SET GLOBAL COLOR
  window.textColor = (mode === "light") ? "#000" : "#fff";

  const textarea = document.getElementById("text_0");

  // 👉 USE PLACEHOLDER IF TEXTAREA IS EMPTY
  const text = textarea.value.trim() || window.placeholderText;
  keepToneArmOnTop();
  drawSpiralLyricsSVG(text);
}




jQuery(document).on("click", ".actionBtn", function () {
  if (jQuery(this).hasClass("darkColor")) {
    updateFontShade("dark");
  }
  if (jQuery(this).hasClass("lightColor")) {
    updateFontShade("light");
  }
});







function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

}

// jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(window['canvas2']);
  });

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    img = newImg;
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('change','.fontFamily',function(){
  var fontID = jQuery(this).attr('data-canvas'),
      textOb = jQuery(this).attr('data-obj');
  canvas = window[fontID];
  activeOb = window[textOb];
  activeOb.set({ fontFamily: this.value });
  canvas.renderAll();
  fitTextToWidth(window['text1Page'], 1200);
  fitTextToBox(window['text2Page'], maxWidth, maxHeight);
});


function loadColorPicker(colorBox){
  jQuery('#'+colorBox).colorpicker({
    inline: true,
    container: true,
    extensions:[{
      name: 'swatches',
      options:{
        colors:{
          'tetrad1': 'transparent',
          'tetrad2': '#e30405',
          'tetrad3': '#197b30',
          'tetrad4': '#0054a5',
          'tetrad5': '#ffcc00',
          'tetrad6': '#f6ebbe',
          'tetrad7': '#ffea00',
          'tetrad8': '#f8931d',
          'tetrad9': '#f499c2',
          'tetrad10': '#959595',
          'tetrad11': '#fef335',
          'tetrad12': '#a0400d',
          'tetrad13': '#000000',
          'tetrad14': '#604973',
          'tetrad15': '#afe8fc',
          'tetrad16': '#fffafa',
          'tetrad17': '#bc8cbe',
          'tetrad18': '#ff69b4',
          'tetrad19': '#93278f',
          'tetrad20': '#009987',
          'tetrad21': '#0af447',
          'tetrad22': '#00008b',
          'tetrad23': '#006400'
        },
        namesAsValues: false
      }
    }],
    template: '<div class="colorpicker">' +
      '<div class="colorpicker-saturation"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-hue"><i class="colorpicker-guide"></i></div>' +
      '<div class="colorpicker-alpha">' +
      '   <div class="colorpicker-alpha-color"></div>' +
      '   <i class="colorpicker-guide"></i>' +
      '</div>' +
      '<div class="colorpicker-bar">' +
      '   <a href="javascript:void(0);" class="button btn-block colorOFF">Ok</a>'+
      '   <div class="ctn-icon-eyedropper dropper-eyedrop"><svg class="icon icon-eyedropper" viewBox="0 0 16 16">'+
      '   <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5'+
      '   0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207'+
      '   1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"/></svg></div>'+
      '</div>' +
      '</div>'
  }).on('colorpickerCreate', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('id'),
        active = colorBox.find('.currentColor'),
        activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
    },200);
  }).on('colorpickerChange', function(){
    var colorBox = jQuery(this);
    setTimeout(function(){
      var colorID = colorBox.attr('data-canvas'),
          textOb = colorBox.attr('data-obj'),
          active = colorBox.find('.currentColor'),
          activeCOLOR = active.attr('value');
      colorBox.find('.colorBox').attr('style','background:'+activeCOLOR+';');
      colorBox.attr('data-color',activeCOLOR);
      canvas = window[colorID];
      activeOb = window[textOb];
      sCAle = activeOb.scaleX;
      activeOb.set('fill',activeCOLOR);
      activeOb.scaleX = .5;
      activeOb.setCoords();
      canvas.renderAll();
      activeOb.scaleX = sCAle;
      activeOb.setCoords();
      canvas.renderAll();
    },200);
  });
  jQuery(document).on('click','.colorBox',function(){
    jQuery('.colorBox').each(function(){
      jQuery(this).next().hide();
    });
    jQuery(this).next().show();
  });
  jQuery(document).on('click','.colorOFF',function(){
    var parENt = jQuery(this).parent().parent(),
        toolBarBox = parENt.parent().parent().parent().attr('id');
    if(toolBarBox === 'labelBase'){
      parENt.parent().parent().parent().parent().removeClass('active');
    }else{
      parENt.hide();
    }
  });
}

function updateFont(activeOb){
  if(activeOb){
    sCAle = activeOb.scaleX;
    activeOb.set('fontSize',fontSize);
    activeOb.set('fontFamily',fontFamily);
    activeOb.set('fill',activeCOLOR);
    activeOb.scaleX = .5;
    activeOb.setCoords();
    canvas.renderAll();
    activeOb.scaleX = sCAle;
    activeOb.setCoords();
    canvas.renderAll();
  }
}

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});




jQuery(window).on('load',function(){
  canvasBlock(canvas2);
  window['text1Page'].set('text','Kinza Rani');
  window['text2Page'].set('text','Lovable creatures that bring joy,\ncomfort, and endless companionship to us.');
  window['canvas2'].renderAll();
  // loadFirstImg();
});


function getCookie(name){
  let nameEQ = name + "=";
  let cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++){
    let cookie = cookies[i].trim();
    if(cookie.indexOf(nameEQ) === 0){
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

window.addEventListener("load", function(){
  if(getCookie("firstVisit")){
    console.log("✅ Cookie exists:", getCookie("firstVisit"));
  } else{
    console.log("❌ Cookie does not exist!");
    document.cookie = "firstVisit=textresizing; expires=" + new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString() + "; path=/;";
    location.reload();
  }
});



/* fetch Call */
// var size,thumbnail;
var loadedObject,backgroundDesign,searchSong,songLyrics,enterName,Font1,enterQuote,Font2,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    window['canvas2'] = canvas.toDataURL('image/png');
    backgroundDesign = backgroundDesign;
    searchSong = jQuery('.search-song-input input').val();
    songLyrics = jQuery('.enter_text textarea').val();
    enterName = jQuery('.enter_name input').val();
    Font1 = jQuery('.choose_font1 option:selected').val();
    enterQuote = jQuery('.enter_quote textarea').val();
    Font2 = jQuery('.choose_font2 option:selected').val();
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#backgroundDesign').val(backgroundDesign);
      jQuery('#searchSong').val(searchSong);
      jQuery('#songLyrics').val(songLyrics);
      jQuery('#enterName').val(enterName);
      jQuery('#Font1').val(Font1);
      jQuery('#enterQuote').val(enterQuote);
      jQuery('#Font2').val(Font2);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      jQuery('.product-form__buttons .product-form__submit').trigger('click');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});

function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}